@use "ui/styles/colors";
@use "ui/styles/fonts";
@use "ui/styles/sizes";

.root {
    color: var(--label-text-color, var(--text-color));
    font-size: var(--label-font-size, fonts.$mid);
    font-weight: fonts.$book;
    // Prevent text selection when double clicking
    user-select: none;

    &:hover {
        color: var(--label-text-color-hover, var(--text-color));
    }

    &.disabled {
        color: var(--disabled-text-color, var(--secondary-text-color));
        cursor: not-allowed;
    }

    &.clickable {
        cursor: pointer;
    }
}

.content {
    display: flex;
    align-items: center;
    gap: sizes.$s3;
    width: fit-content;
}

.tooltipIcon {
    flex-shrink: 0;
    color: var(--secondary-text-color);
    cursor: help;
    width: 1.2em;
    height: 1.2em;
    transition: color 0.2s ease;

    &:hover {
        color: var(--text-color);
    }
}

.requiredIndicator {
    color: var(--required-indicator-color, colors.$red);
}